/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type MultitxtDeliveryReportDto = {
    messageId: string;
    /**
     * Current Multitxt account field; treated as status when status is omitted
     */
    messageStatus?: string;
    status: string;
    statusCode: string;
    renewalId: string;
    notificationType: MultitxtDeliveryReportDto.notificationType;
    occurredAt?: string;
};
export namespace MultitxtDeliveryReportDto {
    export enum notificationType {
        INTERNAL_MANUAL_ALERT = 'INTERNAL_MANUAL_ALERT',
        CLIENT_EMAIL_20_DAY = 'CLIENT_EMAIL_20_DAY',
        CLIENT_SMS_20_DAY = 'CLIENT_SMS_20_DAY',
        CLIENT_EMAIL_7_DAY = 'CLIENT_EMAIL_7_DAY',
        CLIENT_SMS_7_DAY = 'CLIENT_SMS_7_DAY',
        CLIENT_SMS_DAY_BEFORE = 'CLIENT_SMS_DAY_BEFORE',
        CLIENT_EMAIL_DAY_OF_UNPAID = 'CLIENT_EMAIL_DAY_OF_UNPAID',
        CLIENT_EMAIL_DAY_OF_PAID = 'CLIENT_EMAIL_DAY_OF_PAID',
        ADVISER_EMAIL_DAY_OF_UNRENEWED = 'ADVISER_EMAIL_DAY_OF_UNRENEWED',
    }
}

